import { TheSFTAddress } from "./TheSFT";

export const FantomTheSFTAddress = TheSFTAddress